import {
  GET_RESPONSE_TYPE,
  brandPerformanceConstants,
  AVERAGE_RATING_RESPONSE_TYPE,
  successMessages,
  toastTypes,
} from "../../constants";
import { customToast } from "../../../../shared";
import { brandPerformanceService } from "../../services";
import {
  success,
  withSpinner,
  failure,
} from "../../../../redux/actions/utilities";
import { managerPerformanceConstants } from "../../../manager-screens/constants";

const {
  ALL_GROUP_RESPONSE_DATA,
  ALL_RESTAURANT_RESPONSE_DATA,
  GET_AVERAGE_RATING_RESPONSES,
  GET_RECORD_PAGINATION_RESPONSES,
  CUSTOMER_RESPONSES_EXPORT_ALL_DATA,
  GROUPS_AVERAGE_SENTIMENT_AND_TRANSACTION_RATING,
  STORES_AVERAGE_SENTIMENT_AND_TRANSACTION_RATING,
  EXPORT_DETAILED_CUSTOMER_SURVEY_DATA,
} = brandPerformanceConstants;

const { ALL_MANAGER_RESPONSE_DATA } = managerPerformanceConstants;
const { GET_RESTAURANT_RESPONSES, GET_GROUP_RESPONSES } = GET_RESPONSE_TYPE;

const getAllRestaurantResponsesItemsForExport = (
  createDateFrom,
  createDateTo,
  brandId,
  body,
) => {
  return (dispatch) => {
    withSpinner(dispatch, ALL_RESTAURANT_RESPONSE_DATA, () =>
      brandPerformanceService
        .getRecordPaginationResponses({
          createDateFrom: createDateFrom,
          createDateTo: createDateTo,
          id: brandId,
          type: GET_RESTAURANT_RESPONSES,
          ...body,
        })
        .then(
          (response) => {
            dispatch(
              success(
                response.pageData.result,
                CUSTOMER_RESPONSES_EXPORT_ALL_DATA,
              ),
            );
          },
          (error) => {
            dispatch(resetAllExportItems());
            customToast(error[0], toastTypes.ERROR);
          },
        )
    );
  };
};

const getAllFranchiseResponseItemsForExport = (
  createDateFrom,
  createDateTo,
  brandId,
  body,
) => {
  return (dispatch) => {
    withSpinner(dispatch, ALL_GROUP_RESPONSE_DATA, () =>
      brandPerformanceService
        .getRecordPaginationResponses({
          createDateFrom: createDateFrom,
          createDateTo: createDateTo,
          id: brandId,
          type: GET_GROUP_RESPONSES,
          ...body,
        })
        .then(
          (response) => {
            dispatch(
              success(
                response.pageData.result,
                CUSTOMER_RESPONSES_EXPORT_ALL_DATA,
              ),
            );
          },
          (error) => {
            dispatch(resetAllExportItems());
            customToast(error[0], toastTypes.ERROR);
          },
        )
    );
  };
};

const resetAllExportItems = () => {
  return (dispatch) => {
    dispatch(failure([], CUSTOMER_RESPONSES_EXPORT_ALL_DATA));
  };
};

const exportDetailCustomerSurveyData = (fromDate, toDate, brandId) => {
  return (dispatch) => {
    return withSpinner(dispatch, EXPORT_DETAILED_CUSTOMER_SURVEY_DATA, () =>
      brandPerformanceService
        .exportDetailCustomerSurveyData(fromDate, toDate, brandId)
        .then(
          (response) => {
            dispatch(success(response, EXPORT_DETAILED_CUSTOMER_SURVEY_DATA));
            customToast(
              successMessages.EXPORT_DETAIL_CUSTOMER_SURVEY_DATA_SUCCESS_MESSAGE,
              toastTypes.SUCCESS,
              8000,
            );
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
            throw error;
          },
        ),
    );
  };
};

const getAverageRatingResponses = (payload) => {
  return (dispatch) => {
    // Activate spinner
    withSpinner(dispatch, GET_AVERAGE_RATING_RESPONSES, () =>
      brandPerformanceService
        .getAverageRatingResponses(payload)
        .then(
          (response) => {
            const { type } = payload;

            // Group-based average rating
            if (
              type ===
              AVERAGE_RATING_RESPONSE_TYPE.GET_GROUPS_AVERAGE_RATING_RESPONSES
            ) {
              dispatch(
                success(
                  response,
                  GROUPS_AVERAGE_SENTIMENT_AND_TRANSACTION_RATING,
                ),
              );
              return;
            }

            const storeRatingTypes = [
              AVERAGE_RATING_RESPONSE_TYPE.GET_STORE_AVERAGE_RATING_RESPONSES,
              AVERAGE_RATING_RESPONSE_TYPE.GET_GROUP_AVERAGE_RATING_RESPONSES,
              AVERAGE_RATING_RESPONSE_TYPE.GET_MANAGER_AVERAGE_RATING_RESPONSES,
              AVERAGE_RATING_RESPONSE_TYPE.GET_INDIVIDUAL_STORE_AVERAGE_RATING_RESPONSE,
            ];

            if (storeRatingTypes.includes(type)) {
              dispatch(
                success(
                  response,
                  STORES_AVERAGE_SENTIMENT_AND_TRANSACTION_RATING,
                ),
              );
            }
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          },
        )
    );
  };
};

const getRecordPaginationResponses = (payload) => {
  return (dispatch) => {
    // Activate spinner
    withSpinner(dispatch, GET_RECORD_PAGINATION_RESPONSES, () =>
      brandPerformanceService
        .getRecordPaginationResponses(payload)
        .then(
          (response) => {
            const { type } = payload;

            if (type === GET_RESPONSE_TYPE.GET_RESTAURANT_RESPONSES) {
              dispatch(success(response, ALL_RESTAURANT_RESPONSE_DATA));
              return;
            }

            const groupResponseTypes = [
              GET_RESPONSE_TYPE.GET_GROUP_RESPONSES,
              GET_RESPONSE_TYPE.GET_GROUP_USER_RESPONSES,
            ];

            if (groupResponseTypes.includes(type)) {
              dispatch(success(response, ALL_GROUP_RESPONSE_DATA));
              return;
            }

            if (type === GET_RESPONSE_TYPE.GET_MANAGER_USER_RESPONSES) {
              dispatch(success(response, ALL_MANAGER_RESPONSE_DATA));
            }
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          },
        )
    );
  };
};

export const brandPerformanceActions = {
  resetAllExportItems,
  getAverageRatingResponses,
  getRecordPaginationResponses,
  exportDetailCustomerSurveyData,
  getAllFranchiseResponseItemsForExport,
  getAllRestaurantResponsesItemsForExport,
};
